module.exports = __webpack_public_path__ + "2e5f48b3996c75c52af01e8b618fe104.png";